import gql from "graphql-tag";

export default gql`
  mutation VerifyCustomerCode($customerId: ID!, $customerRequestCode: String!) {
    verifyCustomerCode(
      customerId: $customerId
      customerRequestCode: $customerRequestCode
    ) {
      id
      verified
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/VerifyCustomerCode.ts